export class DialogConfig<D = any> {
    data?: D;
  }
